import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-plant-line text-lg text-background-50"></i>
              </div>
              <span className="text-base font-heading font-bold text-background-50 whitespace-nowrap">
                毒蘑菇测试
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              权威的毒蘑菇鉴别科普平台，帮助您一分钟识别有毒蘑菇真伪，保障野外采摘安全。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
              免责声明
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站提供的内容仅供科普参考，不能替代专业医疗建议。野外采摘蘑菇请务必在有经验人士指导下进行。如怀疑蘑菇中毒，请立即就医。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 毒蘑菇测试 - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}